enum LandingPageSource {
  Campaign = 0,
  Manually = 60,
  DSP = 50,
  FeedItem = 20,
  LocationFeed = 40,
}

enum CreativeFormatSelectionMethod {
  Adaptive = 0,
  ExactSize = 1,
}

export {LandingPageSource, CreativeFormatSelectionMethod};
